import React, { useState } from "react";
import api, { apiError } from "../lib/api";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Reusable AI helper card. `endpoint` is one of the /ai/* routes.
export default function AIPanel({ title, description, endpoint, payload, testid }) {
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    setResult("");
    try {
      const { data } = await api.post(endpoint, payload);
      setResult(data.result);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rounded-xl border border-[#D5CEBF] bg-[#F3EFE4] p-6" data-testid={testid}>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-[#C46B4E]/15 flex items-center justify-center shrink-0">
          <Sparkles className="w-5 h-5 text-[#C46B4E]" />
        </div>
        <div className="flex-1">
          <h4 className="font-heading text-xl text-[#2A2621]">{title}</h4>
          <p className="text-sm text-[#615A50] mt-0.5">{description}</p>
        </div>
      </div>
      <button
        onClick={run}
        disabled={loading}
        data-testid={`${testid}-generate`}
        className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#3D5844] text-white text-sm font-medium hover:bg-[#2F4535] transition-colors disabled:opacity-60"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
        {loading ? "Reflecting…" : "Generate with AI"}
      </button>
      {result && (
        <div className="mt-4 rounded-lg bg-[#FAF7EE] border border-[#D5CEBF] p-4 whitespace-pre-wrap text-[#2A2621] leading-relaxed text-[15px]" data-testid={`${testid}-result`}>
          {result}
        </div>
      )}
    </div>
  );
}
